import React from 'react';

export function useIntersectionObserver({
  root,
  target,
  onIntersect,
  threshold = 1.0,
  rootMargin = '0px',
  enabled = true,
}: any) {
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries: any) =>
        entries.forEach((entry: any) => entry.isIntersecting && onIntersect()),
      {
        root: root && root.current,
        rootMargin,
        // threshold,
        threshold: 0.25,
      },
    );
    const el = target && target.current;

    if (!el) {
      return;
    }
    observer.observe(el);

    return () => {
      observer.unobserve(el);
    };
  }, [target.current, enabled, onIntersect, root]);
}
